<div class="container-fluid-page">
    <div class=" profile_details">
        <div class="container-fluid page">
            <div class="d-flex page__box p-3 mt-2">&nbsp;&nbsp;Setting</div>
            <div class=" profile_details">

                <div class="page__content shadow p-3">
                    <div class="row">
                        <div class="access"
                            style="float: right; margin-top: 14px;margin-bottom: 14px;margin-left: 12px;font-size: 18px !important;">
                            <b>Contact Information</b>
                        </div>
                        <form [formGroup]="form">
                            <div>
                                <label for="call" style="font-size: 20px;margin-left: 26px;">What's App Number </label>
                                <input type="text" formControlName=whatsupNo class="form-control"
                                    (focusout)="checkValue('whatsupNo', $event)"><br>
                                <small *ngIf="form.get('whatsupNo').invalid && form.get('whatsupNo').touched"
                                    class="alert">What's App Number is required upto 10 digits.</small><br>

                                <label for="phone" style="font-size: 20px;margin-left: 32px;">
                                    <h5>Call Center Number</h5>
                                </label>
                                <input type="text" formControlName=phoneNo class="form-control2"
                                    (focusout)="checkValue('phoneNo', $event)"><br>
                                <small *ngIf="form.get('phoneNo').invalid && form.get('phoneNo').touched"
                                    class="alert">Call Center Number is required upto 11 digits.</small><br>

                            </div>

                            <hr style="margin-top: 26px;margin-left: 12px;">
                            <div class="row">
                                <div
                                    style="float: right; margin-top: 20px;margin-left: 27px;font-size: 23px !important;white-space: normal;">
                                    <h5>Maximun duration allowed for a product availability(months)</h5><br>
                                    <h6>Minimum 1 month, Maximun 6
                                        months, Default duration is 2 months</h6>
                                </div>
                                <input type="text" (focusout)="checkValue('availabilityInMonth' ,$event)"
                                    formControlName=availabilityInMonth class="form-control1">
                            </div>

                            <hr style="margin-top: 40px;margin-left: 12px;">
                            <div class="button" style="float:right; ">


                                <button mat-raised-button class="btn btncls" (click)="onClose()">Cancel</button>
                                <button mat-raised-button class="btn btncls1" (click)="onSubmit()"
                                    [disabled]=isButtonDisable>Apply</button>
                            </div>
 

                            <div class="SFheading" style=" height: 50px;
                            width: 103%;
                            margin-top: 75px;
                            margin-left: -15px;
                            font-size: 21px;
                            padding: 10px;
                           text-align: start;
                           background: #234a90;
                           border: none;
                           color: white;">&nbsp;&nbsp;&nbsp;&nbsp;Synch Data with Salesforce</div>


                            <div>
                                <input type="radio" name="syncBasedOn" class="custom-control-input" formControlName="syncBasedOn" value = allRecords
                                (change)="checkRadio()" />
                                <label class="custom-control-label" for="daterange">All Records(will take a long time to
                                    complete)</label>
                            </div>

                            <div>
                                  <input type="radio"  class="custom-control-input" (change)="checkRadio()"
                                name="syncBasedOn" formControlName="syncBasedOn" value = dateRange />
                                <input placeholder="Records in date range(Choose a date)" class="id2" autocomplete="off"
                                    [dateLimit]="dateLimit" formControlName="selectedDate" [isInvalidDate]="isInvalidDate"
                                    [isTooltipDate]="isTooltipDate" [maxDate]='maxDate'  [alwaysShowCalendars]="true" 
                                    ngxDaterangepickerMd  [showCancel]="true"
                                     [locale]="{applyLabel: 'Ok', format: 'DD MMM,YYYY',
                                          cancelLabel: 'Cancel'}" [showCustomRangeLabel]="true"  (change)="onDateRangeChanged(sharedate)" [(ngModel)]="sharedate"
                                    />
                                <br>


                            </div><br>
                            <div id="disp" style="color:green; font-size:18px; font-weight:bold;">
                            </div>



                            <h6>Last synched&nbsp;{{avgData.lastSynchStatus}}&nbsp;on
                                &nbsp;<b>{{avgData.lastSynchDate}}</b>,&nbsp; by&nbsp;<b>{{avgData.updatedBy}}</b></h6>
                            <button mat-raised-button style="float:right" class="btn btncls3" (click)="onSync()">Synch
                                Data Now</button>

                        </form>

   
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>